module.exports = __webpack_public_path__ + "static/teag-2d7c15ae32f2fe88a0575ca5ba18abbc.png";